/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:10:17
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-28 11:52:57
 */
import { notification, Pagination, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../app/store";
import styles from "./warningRule.module.css";
import { WarningRuleQuerys } from "./query";
import { warningRuleColumn } from "./columns";
import { WarningRuleDetailModal } from "./modal";
import { getWarningRuleListAsync, selectWarningRuleList } from "./warningRuleSlice";
import { WarningRuleParams } from "../../services/warningRule";

export const WarningRuleMessage = () => {
  const dispatch = useDispatch<AppDispatch>();

  const data = useSelector(selectWarningRuleList);

  const [id, setId] = useState("")

  const [IsVisible, setIsVisible] = useState(false);

  const [queries, setQueries] = useState<WarningRuleParams>({
    pn: 1,
    ps: 10,
  });

  useEffect(() => {
    if (JSON.stringify(queries) !== "{}") {
      dispatch(getWarningRuleListAsync({ ...queries }));
    }
  }, [dispatch, queries]);
  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          height: "120px",
          display: "flex",
          flexDirection: "column",
          marginBottom: "10px",
        }}
      >
        <div
          style={{
            flex: "1",
            background: "#fff",
            borderRadius: "10px",
            padding: "20px",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>查询条件</h3>
          <WarningRuleQuerys
            onValueChange={(v) => {
              setQueries({ ...v, pn: 1, ps: 10 });
            }}
          />
        </div>
      </div>
      <div
        style={{ height: "calc(100% - 130px)" }}
        className={styles.WarningRuleStation}
      >
        <div
          style={{
            width: "100%",
            height: "calc(100% - 55px)",
            overflow: "auto",
          }}
        >
          <Table
            rowKey={(record, i) => data.size * (data.current - 1) + (i || 0)}
            className={styles.WarningRuleTable}
            pagination={false}
            style={{ height: "100%" }}
            dataSource={data.records}
            columns={warningRuleColumn((text, ruleId) => {
              if (text === "look") {
                setId(ruleId)
                setIsVisible(true);
              } else if (text === "uplode") {
                notification.error({
                  message: "暂时没有可下载的算法",
                  duration: 3,
              });
              } else {
                return
              }
            }, data.size * (data.current - 1))}

          ></Table>
          <Pagination
            total={data.total}
            current={data.current}
            pageSize={data.size}
            showSizeChanger
            showQuickJumper
            style={{
              position: "absolute",
              bottom: "40px",
              right: "40px",
            }}
            showTotal={(total) => `共 ${total} 条`}
            onChange={(current, size) => {
              setQueries({ ...queries, pn: current, ps: size });
            }}
          />
        </div>
        <WarningRuleDetailModal
          visible={IsVisible}
          crId={id}
          onCancel={() => {
            setIsVisible(false);
          }}
          onOk={() => {
            setIsVisible(false);
            dispatch(
              getWarningRuleListAsync({ ...queries })
            );
          }}
        />
      </div>
    </div>
  );
};
